import { render, staticRenderFns } from "./FilterLayoutSwitch.vue?vue&type=template&id=1651517a"
import script from "./FilterLayoutSwitch.vue?vue&type=script&lang=ts"
export * from "./FilterLayoutSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports